module.exports = __webpack_public_path__ + "static/media/date-icon.b88b37d1.svg";